module.exports = new __parcel__URL__("book.8e19e8c6.png").toString();